module.exports = __webpack_public_path__ + "static/home-product3-250fd78cfe218f6d67cf7174a123e0b6.png";